import { useEffect, useState } from 'react';

export function useShouldShowFileActions(
  metadata,
  row,
  user,
  isSharedWithMeTabActive,
  isAnonymous
) {
  const isRevenueBaseFile = metadata?.Owner === 'revenuebase@gigasheet.com';
  const revenueBaseAccess = !!user?.userProperties?.revenueBaseAccess;
  const [shouldShowFileActions, setShouldShowFileActions] = useState(false);

  useEffect(() => {
    setShouldShowFileActions(
      !(revenueBaseAccess && isRevenueBaseFile) &&
        (!isSharedWithMeTabActive ||
          (!isAnonymous && !(row?.IsDirectory && row?.permissions?.length === 0)))
    );
  }, [isSharedWithMeTabActive, isAnonymous, revenueBaseAccess, isRevenueBaseFile, row]);

  return shouldShowFileActions;
}
